module.exports = __webpack_public_path__ + "img/J13209.932cbbeb.png";